import cn from 'classnames';
import { AnchorArrow, Box } from 'react-scale/components';

// This is old code copy-pasted from last years detail page. @Todo
const Sessions = ({ sessions }) => (
  <div
    className={cn(
      'grid gap-12',
      sessions.filter(({ watchVideoCta }) => watchVideoCta).length === 1
        ? 'grid-cols-1'
        : 'sm:grid-cols-2'
    )}
  >
    {sessions.map(
      ({ watchVideoCta }) =>
        watchVideoCta && (
          <a href={watchVideoCta.href} target="_blank" rel="noreferrer">
            <Box type="gradient">
              <div
                className={cn(
                  'flex justify-between p-10 h-full',
                  sessions.length > 1
                    ? 'flex-col space-y-6 items-baseline'
                    : 'flex-col md:flex-row items-baseline md:items-center space-y-6 md:space-y-0 md:space-x-6'
                )}
              >
                <p className="inline-block text-white md:text-lg font-aeonik">
                  {watchVideoCta.label}
                </p>
                <AnchorArrow
                  href={watchVideoCta.href}
                  openInNewTab={watchVideoCta.openInNewTab}
                  className="font-medium transition-colors text-scale-lightmauve hover:text-scale-mauve max-w-max"
                >
                  Watch Video
                </AnchorArrow>
              </div>
            </Box>
          </a>
        )
    )}
  </div>
);

export default Sessions;
